import { Box } from '@mui/material';
import { ServiceItem } from 'orderme-api-integration-client';
import { ImageLoader } from '../imgLoader/imgLoader';
import { apiKey, imagesUri } from '../../helpers/clientConfigs';
import ClothesIcon from '../../logo/laundry-clothes.png';
import SewingIcon from '../../logo/sewing.png';
import { isSewingService } from '../../helpers/servicesHelper';

interface CartProductDetailsProps {
  item: ServiceItem;
}

export function CartProductDetails({ item }: CartProductDetailsProps) {
  const isSewing = isSewingService(item);
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        color: 'black',
        fontSize: '19px',
      }}
    >
      <Box sx={{ width: '100px', flexShrink: 0, textAlign: 'center' }}>
        {item.logoId ? (
          <ImageLoader
            src={`${imagesUri}/${item.logoId}?orderme-api-key=${apiKey}&height=500`}
            sx={{ maxHeight: '75px', maxWidth: '100px' }}
            alt={item.name}
          />
        ) : (
          <ImageLoader
            src={isSewing ? SewingIcon : ClothesIcon}
            sx={{ maxHeight: '75px', maxWidth: '75px', py: '10px' }}
            alt={isSewing ? 'sewing' : 'clothes'}
          />
        )}
      </Box>
      {item.name}
    </Box>
  );
}
